import POPUP_MESSAGE_TYPE from "./popupMessageType";
export default {
    [POPUP_MESSAGE_TYPE.ERROR]: {
        bg: "notify-error-bg",
        border: "notify-error-border"
    },
    [POPUP_MESSAGE_TYPE.INFO]: {
        bg: "notify-info-bg",
        border: "notify-info-border"
    },
    [POPUP_MESSAGE_TYPE.SUCCESS]: {
        bg: "notify-success-bg",
        border: "notify-success-border"
    }
};
